import { InjectionToken } from '@angular/core';

export const INDEXED_DB_CONFIG_TOKEN: InjectionToken<string> = new InjectionToken<IndexedDbConfig>('__INDEXED_DB_CONFIG__');

export interface IndexedDbConfig {
  databaseName: string;
  databaseSchema: {
    databaseSchemaChange: any;
    databaseVersion: number;
    databaseUpgrade?: {
      table: string;
      upgradeFn: () => void;
    };
  }[];
  foreignKeyErrors?: boolean;
}
